<template>
  <butn 
    btntype="primary"
    :title="btnDisable ? `刷新(${this.countDown}s)` : '刷新' "
    :disabled="btnDisable"
    @click.native="refresh"
  >
  </butn>
</template>
<script>
import butn from "@/components/button/index";
export default {
  components: {butn},
  data() {
    return {
      countDown: 10,
      btnDisable: false,
    };
  },
  created() {},
  activated() {},
  computed: {},
  methods: {
    refresh() {
      this.btnDisable = true;
      this.$listeners.refresh && this.$listeners.refresh();
      const t = setInterval(() => {
        this.countDown--
        if (this.countDown === 0) {
          this.countDown = 10
          this.btnDisable = false;
          clearInterval(t)
        }
      }, 1000)
    }
  },
};
</script>
<style lang='scss' scoped>
</style>